export const NS_GS = "https://grafsync.graphifi.com/schema/gs/";
export const USER_NAMESPACE = "https://graphifi.com/data/user/";
export const INVITATION_NAMESPACE = "https://graphifi.com/data/invitation/";
export const SUBSCRIPTION_NAMESPACE = "https://graphifi.com/data/subscription/";
export const INTEGRATION_NAMESPACE = "https://grafsync.graphifi.com/data/integration/";
export const PROJECT_NAMESPACE = "https://grafsync.graphifi.com/data/project/";
export const SNAPSHOT_CONFIGURATION_NAMESPACE = "https://grafsync.graphifi.com/data/snapshotconfiguration/";
export const GRAPH_IRI_SYSTEM = "https://grafsync.graphifi.com/graph/system";
export const GRAPH_IRI_SECURITY = "https://grafsync.graphifi.com/graph/security";

export const STATUS_ACCEPTED = "https://grafsync.graphifi.com/schema/gs/accepted";
export const STATUS_PENDING = "https://grafsync.graphifi.com/schema/gs/pending";
export const STATUS_REJECTED = "https://grafsync.graphifi.com/schema/gs/rejected";
